/* ------------------------------------------- +
 |  Busca as configs da aplicação no back-end  |
 + ------------------------------------------- */
export default async function ({ store }) {
  if (Object.keys(store.state.config.default_options).length === 0) {
    await store.dispatch('config/getDefaultOptions')
  }
}
